
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import LogoShowcase from './components/LogoShowcase';
import DivisionsSection from './components/DivisionsSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <HeroSection />
      <AboutSection />
      <LogoShowcase />
      <DivisionsSection />
      <Footer />
    </div>
  );
};

export default HomePage;
